import { api } from '../../../api/index';
import { actions } from '../../../../store/actions/index';

export const addDriver = data => async dispatch => {
  try {
    await api.addDriver(data);
    dispatch(actions.closeModal.act('addDriver'));
    dispatch(actions.needToUpdateData.act(true));
  } catch (e) {
    return e;
  }
};
